import { SelectRef } from '@/components/Select/Select';
import { KEY_EVENT_KEYS } from '@/config/constants';
import { useConfigContext } from '@/context/configContext';
import { CurrencyInput, Tooltip, Typography } from '@analytical-alley/ui';
import { Label } from 'flowbite-react';
import { useRef } from 'react';

const BudgetInput = ({
    estimatedBudget,
    setEstimatedBudget,
    disabled = false,
    label = 'Media budget',
    limits,
}: {
    estimatedBudget: number | undefined;
    setEstimatedBudget: (value: number | undefined) => void;
    disabled?: boolean;
    label?: string;
    limits: { min: number; max: number } | null;
}) => {
    const selectRef = useRef<SelectRef>(null);
    const { locale, currency, formatNumber } = useConfigContext();

    return (
        <div>
            <div className="mb-1 block">
                <Label
                    onClick={() => {
                        selectRef?.current?.click?.();
                    }}
                    className="font-mono font-normal text-nowrap truncate"
                    htmlFor="budget"
                >
                    {label}
                </Label>
            </div>

            <Tooltip placement="bottom">
                <Tooltip.Trigger asChild>
                    <CurrencyInput
                        id="budget"
                        className="w-full self-center text-nowrap justify-center px-4 py-2 text-sm leading-5 rounded-lg shadow-lg backdrop-blur-[15px] bg-white/10 glass text-dark dark:text-white border-0 focus:ring-1 focus:ring-[#1C64F2] focus-visible:outline-hidden dark:shadow-sm-light disabled:opacity-50"
                        intlConfig={{ locale, currency }}
                        decimalScale={0}
                        disabled={disabled}
                        value={estimatedBudget ?? ''}
                        onBlur={() => {}}
                        groupSeparator={' '}
                        onKeyDown={async (e) => {
                            if (e.key === KEY_EVENT_KEYS.ENTER) {
                                // do nothing
                            }
                        }}
                        onValueChange={(_, _1, values) => {
                            const value = values?.float;

                            if (value == null || value < 0) {
                                setEstimatedBudget(0);
                                return;
                            }

                            setEstimatedBudget(value);
                        }}
                    />
                </Tooltip.Trigger>
                {limits && (
                    <Tooltip.Content className="tooltip-content">
                        <table className="font-sans">
                            <tbody>
                                <tr>
                                    <td className="pr-2">
                                        <Typography className="text-black dark:text-black">
                                            Selected Budget:
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography className="text-dark dark:text-dark">
                                            {estimatedBudget
                                                ? formatNumber(estimatedBudget)
                                                : '-'}
                                        </Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="pr-2">
                                        <Typography className="text-black dark:text-black">
                                            Minimum Recommended Value:
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography className="text-dark dark:text-dark">
                                            {formatNumber(limits.min)}
                                        </Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="pr-2">
                                        <Typography className="text-black dark:text-black">
                                            Maximum Recommended Value:
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography className="text-dark dark:text-dark">
                                            {formatNumber(limits.max)}
                                        </Typography>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Tooltip.Content>
                )}
            </Tooltip>
        </div>
    );
};

export default BudgetInput;
